import { useState } from "react";

export default function (defaultTab = "EVENT") {
	const [history, setHistory] = useState([defaultTab]);
	const [currentIndex, setCurrentIndex] = useState(0);

	const currentTab = history[currentIndex];

	const push = (tab) => {
		if (tab !== currentTab) {
			const newHistory = history.slice(0, currentIndex + 1);
			newHistory.push(tab);
			setHistory(newHistory);
			setCurrentIndex(newHistory.length - 1);
		}
	};

	const back = () => {
		if (currentIndex > 0) {
			setCurrentIndex((i) => i - 1);
		}
	};

	const forward = () => {
		if (currentIndex < history.length - 1) {
			setCurrentIndex((i) => i + 1);
		}
	};

	return { currentTab, push, back, forward, history, currentIndex };
}